export const BACKEND_PROPAGATION_DELAY_MS = 2000



// WEBPACK FOOTER //
// ./src/constants/delays.js